// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "technique".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "technique" table (1:1 with a DB row, on the wire). */
export const techniqueAtomSchema = z.object({
    slug: z.string(),
    displayName: z.string(),
    visualSignature: z.string().nullable(),
    isProcedural: z.boolean(),
    parentSlug: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=technique.js.map